// IKAIKA: the theme's "thumbnails" gallery style lays out desktop as a fixed
// CSS grid, [narrow rail][wide slot], assuming the thumbnail strip is the
// FIRST child and the main image second. We render the main image first and
// the thumbnail strip after (so thumbnails sit below instead of beside on
// desktop). That flips which element lands in the narrow vs. wide grid slot.
//
// A CSS override with !important fixed the sizing but also defeated the
// theme's own responsive show/hide between its separate mobile and desktop
// media containers (both are always in the DOM; CSS toggles which is
// visible), causing both to render stacked at once. Doing this in JS instead,
// applied only to whichever container is actually visible right now, so it
// can never fight the theme's own breakpoint logic.
(function () {
  function isHidden(el) {
    return getComputedStyle(el).display === 'none';
  }

  function clear(container) {
    container.style.display = '';
    container.style.flexDirection = '';
    container.style.height = '';
    container.style.gap = '';

    ['.product__media', '.product-thumbnails'].forEach(function (selector) {
      var child = container.querySelector(selector);
      if (!child) return;
      child.style.width = '';
      child.style.height = '';
      child.style.flex = '';
    });
  }

  function apply(container) {
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.height = 'auto';
    container.style.gap = '1rem';

    ['.product__media', '.product-thumbnails'].forEach(function (selector) {
      var child = container.querySelector(selector);
      if (!child) return;
      child.style.width = '100%';
      child.style.height = 'auto';
      child.style.flex = 'none';
    });
  }

  function run() {
    var containers = document.querySelectorAll(
      '.product__media-container[data-gallery-style="thumbnails"]'
    );

    containers.forEach(clear);
    containers.forEach(function (container) {
      if (!isHidden(container)) apply(container);
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
